import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
import { GameConstants } from "../../constant/GameConstants";
/**
 * ProgressiveJackpotData.ts
 */
export class ProgressiveJackpotData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.name = this.data.getString(GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_NAME);
            this.priority = this.data.getNumber(GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_PRIORITY);
            this.amount = this.data.getNumber(GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_AMOUNT);
        }
    }
    getName() {
        return this.name;
    }
    getPriority() {
        return this.priority;
    }
    getAmount() {
        return this.amount;
    }
}
//# sourceMappingURL=ProgressiveJackpotData.js.map